import axios from 'axios'
import rateLimit from 'axios-rate-limit'
axios.defaults.baseURL = process.env.GATSBY_API_URL
axios.defaults.headers.common['Content-Type'] = 'application/json'
export const http = rateLimit(axios.create(), { maxRequests: 5, perMilliseconds: 250, maxRPS: 5 })
